import { gsap } from 'gsap';
import { prettyLetter } from 'pretty-letters';

import { app } from '../../utils/store';

export default class Theme {
    constructor(){
        this.view = document.querySelector('html');
        this.switcher = document.getElementById('darkmode');
        this.overlay = document.querySelector('.app-overlay');
    }

    init() {
        if(Sniff.features.mobile){
            this.overlay.remove();
        } else if(this.switcher && this.overlay){
            this.set();
            this.toggler();
        }
    }

    toggler = () => {
        this.switcher.addEventListener('click',() => {
            this.switcher.classList.toggle('active');
            this.cookie();
            this.title();
            this.transition();
        });
    }

    title = () => {
        var title = document.createElement('div');
        const light = this.overlay.getAttribute('data-light');
        const dark = this.overlay.getAttribute('data-dark');

        if(this.view.classList.contains('lightmode')){
            title.appendChild(
                document.createTextNode(dark)
            );
        } else {
            title.appendChild(
                document.createTextNode(light)
            );
        }

        title.classList.add('d-flex');
        title.classList.add('title');

        if(this.overlay.childElementCount > 0){
            this.overlay.innerHTML = '';
            this.overlay.appendChild(title);
        } else {
            this.overlay.appendChild(title);
        }

        prettyLetters(title, {
            charClass: 'char-',
            groupClass: 'word-',
            charTag: 'span',
            groupTag: 'span',
        });
    }

    transition = () => {
        gsap.to(this.overlay, 1,{
            y: 0,
            ease: 'expo.easeIn',
        });

        gsap.to(this.overlay, 1,{
            delay: 1.25,
            onStart: () => {
                this.overlay.classList.add('clip');
            },
            onComplete: this.set(),
        });

        gsap.from('.app-overlay [class*="char-"]', {
            y: 200,
            autoAlpha: 0,
            stagger: .05,
            ease: 'expo.easeInOut',
            onComplete: () => {
                this.view.classList.toggle('lightmode');
            },
        });

        gsap.to('.app-overlay [class*="char-"]', {
            delay: 1.25,
            y: 50,
            autoAlpha: 0,
            stagger: .025,
            ease: 'expo.easeInOut',
        });
    }

    set = () => {
        this.overlay.classList.toggle('light');
        this.overlay.classList.remove('clip');

        gsap.set(this.overlay, {
            y: '100%',
        });
    }

    cookie = () => {
        var mode = getCookie("mode");

        if(mode == 'dark'){
            setCookie("mode","light");
        } else {
            setCookie("mode","dark");
        }

        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        function setCookie(cname, cvalue) {
            var d = new Date();
            d.setTime(d.getTime() + (10*365*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
    }
}
